import { useT } from "@/i18n/LangProvider";
import { useQuoteHref } from "@/i18n/routing";

export default function Hero() {
  const { t } = useT();
  const quoteHref = useQuoteHref();
  const stats = t("hero.stats");

  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-screen starfield overflow-hidden flex items-center"
    >
      <div
        className="absolute left-0 right-0 bottom-[10%] h-[55%] hero-glow pointer-events-none"
        aria-hidden="true"
      />

      <svg
        viewBox="0 0 1440 400"
        preserveAspectRatio="none"
        className="desert-hills"
        aria-hidden="true"
      >
        <defs>
          <linearGradient id="hill1" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#0F1A2E" />
            <stop offset="100%" stopColor="#0B1120" />
          </linearGradient>
          <linearGradient id="hill2" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#0B1120" />
            <stop offset="100%" stopColor="#050912" />
          </linearGradient>
        </defs>
        <path
          d="M0,260 C220,180 380,300 620,240 C860,180 1040,300 1240,220 C1340,180 1400,200 1440,210 L1440,400 L0,400 Z"
          fill="url(#hill1)"
        />
        <path
          d="M0,320 C200,260 420,360 700,300 C940,250 1140,340 1440,280 L1440,400 L0,400 Z"
          fill="url(#hill2)"
        />
      </svg>

      <div className="section-inner relative z-10 px-6 md:px-8 py-32 w-full">
        <div className="max-w-4xl">
          <p className="eyebrow fade-up mb-8" data-testid="hero-eyebrow">
            {t("hero.eyebrow")}
          </p>

          <h1
            className="font-serif fade-up text-[2.6rem] leading-[1.05] sm:text-5xl md:text-6xl lg:text-7xl text-[color:var(--white)] mb-8"
            data-testid="hero-title"
          >
            {t("hero.title1")}
            <br />
            <em className="text-[color:var(--gold-light)] font-medium">
              {t("hero.title2")}
            </em>
          </h1>

          <p
            className="fade-up font-sans-brand text-base md:text-lg max-w-2xl text-[color:var(--muted-white)] leading-relaxed mb-10"
            data-testid="hero-subtext"
          >
            {t("hero.subtext_1")}{" "}
            <span className="text-[color:var(--gold-light)]">
              {t("hero.subtext_price")}
            </span>{" "}
            {t("hero.subtext_2")}
          </p>

          <a
            href={quoteHref}
            className="btn-pill btn-pill-gold fade-up"
            data-testid="hero-cta"
          >
            {t("hero.cta")} →
          </a>

          <div
            className="fade-up mt-16 flex flex-wrap items-center gap-x-8 gap-y-4 max-w-3xl"
            data-testid="hero-stats"
          >
            {Array.isArray(stats) &&
              stats.map((stat, i) => (
                <div key={stat} className="flex items-center gap-6">
                  <span className="font-mono-brand text-xs md:text-sm text-[color:var(--white)]">
                    {stat}
                  </span>
                  {i < stats.length - 1 && <span className="gold-line" />}
                </div>
              ))}
          </div>
        </div>
      </div>
    </section>
  );
}
